import { render, staticRenderFns } from "./PreSale.vue?vue&type=template&id=ff8e5b10&"
import script from "./PreSale.vue?vue&type=script&lang=js&"
export * from "./PreSale.vue?vue&type=script&lang=js&"
import style0 from "./PreSale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports